<mat-card appearance="outlined" class="item-detail" fxFlex="100" fxFlexFill>
  <mat-card-content>
    <div class="mat-panel-title">
      <div class="title simple" fxFlexFill fxFlex="100" fxLayoutAlign="start center"
        fxLayoutAlign.lt-md="space-between center">
        <div fxFlex="100" fxLayoutAlign="start center">
          <span #filter_name>{{filter.name ? filter.name : ( 'flows.detail.filter_name' | translate)}}</span>

          <mat-form-field *ngIf="filter_name.hidden && !is_default">
            <input autoSizeInput matInput [hidden]="!filter_name.hidden" [(ngModel)]="filter.name" minlength="3"
              #editInput (keyup.enter)="inputNameKeyupEnter($event)">
          </mat-form-field>

          <button class="btn-edit" (click)="editStep($event, filter.name); filter_name.hidden = false" mat-icon-button
            fxShow fxHide.lt-md="true" *ngIf="filter_name.hidden">
            <mat-icon class="icon-edit" svgIcon="icon_check"></mat-icon>
          </button>

          <button class="btn-edit" mat-icon-button fxShow fxHide.lt-md="true"
            (click)="filter_name.hidden = true; clickEditName()"
            *ngIf="!filter_name.hidden  && !is_default && !onlyViewer">
            <mat-icon class="icon-edit" svgIcon="icon_edit"></mat-icon>
          </button>
        </div>

        <div fxFlex="initial">
          <button *ngIf="!onlyViewer && index > 0" class="btn-delete" (click)="remove($event)" mat-icon-button fxShow
            fxHide.lt-md="true">
            <mat-icon class="icon-delete">delete_outline</mat-icon>
          </button>
        </div>

        <app-action-menu class="mobile-detail" [classIcon]="'action-icon'" fxHide fxShow.lt-md="true"
          *ngFor="let expression of filter.expression.nary_expr.expression_list">
          <div class="sheet-container-flow-detail">
            <div class="sheet-header" fxLayoutAlign="start center" fxLayoutGap="10px">
              <div class="icon" fxFlex="40px" fxFlex.xs="30px" fxLayoutAlign="center center">
                <mat-icon inline="true">more_horiz</mat-icon>
              </div>
              <div class="sheet-title">{{filter.name}}</div>
            </div>
            <div class="sheet-container">
              <div class="label">{{ 'flows.detail.autorization.matches' | translate}}</div>
              <div class="rule">
                <div class="value primary">{{expression.binary_expr.left.var_expr.var_name}}</div>
                <div class="operator">{{expression.binary_expr.symbol}}</div>
                <div class="value">{{expression.binary_expr.right.const_expr.const}}</div>
              </div>
            </div>
          </div>
        </app-action-menu>
      </div>
    </div>
    <div class="detail simple" fxShow fxHide.lt-md="true">
      <div class="label">{{ 'flows.detail.autorization.matches' | translate}}</div>
      <div class="rule"
        *ngFor="let expression of filter.expression?.nary_expr?.expression_list; let last = last; let first = first; let i = index">
        <div fxFlex fxLayoutGap="15px" fxLayoutAlign="start center">
          <div class="step" fxFlex="30">
            <mat-form-field hideRequiredMarker="true" floatLabel="never">
              <input type="text" placeholder="{{'flows.detail.fields.options' | translate }}" matInput
                [matAutocomplete]="option" (blur)="blurEventOption($event,expression)"
                [formControl]="form.get('options'+expression.binary_expr.id)"
                (ngModelChange)="valuechangeOption(expression, form.get('options'+expression.binary_expr.id).value, $event)">
              <mat-autocomplete autoActiveFirstOption #option="matAutocomplete"
                (optionSelected)="selectedOption(expression, $event.option.value)">
                <mat-option *ngFor="let option of expression.binary_expr.terms_filtered" [value]="option.name">
                  {{option.name}}
                </mat-option>
              </mat-autocomplete>
              <mat-error *ngIf="form.get('options'+expression.binary_expr.id).hasError('options')">
                {{ 'flows.detail.fields.validation' | translate}}
                <strong>'{{form.get('options'+expression.binary_expr.id).errors.options.value}}'</strong>
                {{'flows.detail.fields.alow' | translate}}
              </mat-error>
              <mat-error *ngIf="form.get('options'+expression.binary_expr.id).errors?.required">
                {{'flows.detail.fields.required' | translate}}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="step" fxFlex="30">
            <mat-form-field hideRequiredMarker="true" floatLabel="never">
              <input type="text" matInput placeholder="{{'flows.detail.fields.operators' | translate }}"
                [matAutocomplete]="operator" (blur)="blurEventOperators($event,expression)"
                [formControl]="form.get('operators'+expression.binary_expr.id)"
                (ngModelChange)="valuechangeOperators(expression, form.get('operators'+expression.binary_expr.id).value, $event)">
              <mat-autocomplete autoActiveFirstOption #operator="matAutocomplete">
                <mat-option *ngFor="let operator of expression.binary_expr.operators_filtered" [value]="operator">
                  {{operator}}
                </mat-option>
              </mat-autocomplete>
              <mat-error *ngIf="form.get('operators'+expression.binary_expr.id).hasError('operators')">
                {{ 'flows.detail.fields.validation' | translate}}
                <strong>'{{form.get('operators'+expression.binary_expr.id).errors.operators.value}}'</strong>
                {{'flows.detail.fields.alow' | translate}}
              </mat-error>
              <mat-error *ngIf="form.get('operators'+expression.binary_expr.id).errors?.required">
                {{'flows.detail.fields.required' | translate}}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="step" fxFlex="40">
            <mat-form-field hideRequiredMarker="true" floatLabel="never">
              <input type="text" placeholder="{{'flows.detail.fields.value' | translate }}" matInput
                [matAutocomplete]="exValues" (blur)="blurEventValues($event,expression)"
                [formControl]="form.get('values'+expression.binary_expr.id)"
                (ngModelChange)="valuechangeValues(expression, form.get('values'+expression.binary_expr.id).value, $event)">
              <mat-autocomplete autoActiveFirstOption #exValues="matAutocomplete">
                <mat-option *ngFor="let value of expression.binary_expr.values_filtered" [value]="value">
                  {{value}}
                </mat-option>
              </mat-autocomplete>
              <mat-error *ngIf="form.get('values'+expression.binary_expr.id).hasError('values')">
                {{ 'flows.detail.fields.validation' | translate}}
                <strong>'{{form.get('values'+expression.binary_expr.id).errors.values.value}}'</strong>
                {{'flows.detail.fields.alow' | translate}}
              </mat-error>
              <mat-error *ngIf="form.get('values'+expression.binary_expr.id).errors?.required">
                {{'flows.detail.fields.required' | translate}}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="step" fxFlex="60px" fxLayoutGap="5px" *ngIf="!onlyViewer">
            <div *ngIf="!last" fxLayoutAlign="start center" fxFlex="none">
              <div class="fc-9 fs-12"> {{'flows.detail.fields.and' | translate}}</div>
            </div>
            <div *ngIf="!onlyViewer" class="step" fxLayoutAlign="start center" fxFlex="none" fxLayoutGap="5px">
              <div *ngIf="last && !is_default && !onlyViewer" class="action ic-svg-green c-pointer"
                fxLayoutAlign="center center">
                <mat-icon (click)="createNewExpression()" class="icon-add">add_circle_outline
                </mat-icon>
              </div>
              <div *ngIf="filter.expression?.nary_expr?.expression_list.length > 1 && !is_default && !onlyViewer"
                class="action remove ic-svg-9 c-pointer" fxLayoutAlign="center center">
                <mat-icon (click)="removeStep($event, expression.binary_expr.id)" class="icon-add">delete_outline
                </mat-icon>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>